import { i18n } from '@lingui/core';
import React from 'react';
import { formatRelativeDate } from '../../../common/lib/formatDate';
import { formatDistance } from '../../../common/lib/formatDistance';
import type { BapAd } from '../../../types';
import { useSearchAdContext } from '../SearchAdContext';

type BapLocationProps = {
    ad: BapAd;
    className?: string;
};

export function BapLocation(props: BapLocationProps) {
    const { ad, className = '' } = props;

    const { currentTime } = useSearchAdContext();

    const isSold = ad.flags.includes('sold');

    const dateText = isSold
        ? i18n.t({
              id: 'search.ad.bap.sold',
              message: 'Sold',
          })
        : formatRelativeDate(ad.timestamp, { currentTime });
    const distanceText =
        ad.distance && ad.distance > 0 ? formatDistance(ad.distance) : null;

    return (
        <div className={`text-s s-text-subtle ${className}`}>
            <span>{dateText}</span>
            <span> ∙ </span>
            <span>
                {!ad.distance && ad.location}
                {distanceText}
            </span>
        </div>
    );
}
